export default function() {
  var self = this;

  self.$el = $('#import-course');

  self.terms = JSON.parse($('#term-json').val());
  self.institutions = JSON.parse($('#institution-json').val());

  self.course = ko.observable({
    term_id: ko.observable(),
    institution_id: ko.observable()
  });

  self.selectedTerm = ko.observable();
  self.selectedInstitution = ko.observable();

  if (Kadenze.isKannu) {
    self.course().term_id.extend({required: true});
    self.selectedTerm.extend({required: true});
  } else {
    self.course().institution_id.extend({required: true});
    self.selectedInstitution.extend({required: true});
  }

  self.importCourse = function() {
    if(self.dropzone.files.length === 1) {
      var errors = ko.validation.group(self);
      errors.showAllMessages(); // This will show the message on the field
      if(errors().length) {
        new Kadenze.Notice.error({ message: errors });
      } else {
        Kadenze.UIUtil.showLoadingIndicator(document.getElementById('import-course'));
        self.dropzone.processQueue();
        self.dropzone.on('success', function(file, response) {
          window.location.replace(Kadenze.Routes.root_path());
        });
      }
    } else {
      new Kadenze.Notice.error({ message: 'Please add file to import' });
    }
  };

  self.initDropZones = function($parent, collection){
    var $elements = $parent.find('.js-article-dz');

    $.each($elements, function(index, el) {
      var $el = $(el);
      var $editor = $el.parent().parent();
      var url = Kadenze.Routes.cloner_course_import_path();

      var $imageInput = $el.find('input[name=\'full\']');
      var $thumbInput = $el.find('input[name=\'thumb\']');

      var templateConfig = $el.data('dz-config');
      var message = JST['templates/dropzone-course-import'](templateConfig);

      message = Kadenze.I18n.tt(message, 'en');

      var curFileObj;
      if ($imageInput.length > 0) {
        var imgPath = ( $imageInput.val() )? $thumbInput.val() : '';
        curFileObj = {
          path: imgPath
        };
      }

      var options = {
        method: 'POST',
        dzName: 'course-import',
        previewable: true,
        dzPreview: JST['templates/dropzone-import-preview'](),
        maxFilesize: templateConfig.maxFilesize,
        acceptedFiles: templateConfig.acceptedFiles,
        autoProcessQueue: false
      };

      try {
        if(Dropzone.forElement('#' + $el.attr('id'))) {
          return;
        }
      }
      catch(err) {
        console.warn(err);
      }

      var callbacks = {
        addedfile: function( file, xhr, formData ){
          $('.dz-img__progress_holder').hide();
          // Kadenze.UIUtil.showLoadingIndicator($editor);
        },
        sending: function( file, xhr, formData ){
          formData.append('term_id', self.selectedTerm());
          formData.append('institution_id', self.selectedInstitution());
        },
        success: function( file, response ) {
          Kadenze.UIUtil.showNotice($editor, {
            message:'Course importing, you will receive a notification when complete',
            status:'success'
          }, 300);
        },
        error: function( file, errorMessage ) {
          Kadenze.UIUtil.showNotice($editor, {message:errorMessage}, 300);
        },
        complete: function( file ) {
          // Kadenze.UIUtil.hideLoadingIndicator($editor);
        }
      };

      var courseDZ = new Kadenze.ImageDropZone($el, message, url, callbacks, curFileObj, options );
      self.dropzone = courseDZ;
    });
  };

  self.initUI = function() {
    self.initDropZones(self.$el);
  };

  const __construct = function(that) {
    console.log('constructor called for CourseImportViewModel');
  }(this);

}
